













































import { defineComponent } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';

import uploadImg from '@/renderer/assets/images/functionBox/upload.svg';
import addMemberImg from '@/renderer/assets/images/functionBox/addMember.svg';

export default defineComponent({
  name: 'FunctionBox',
  props: {
    mode: {
      type: Array as () => Array<['buildTeam' | 'uploadFile']>,
      default: () => ['buildTeam', 'uploadFile'],
    },
    buildTeamInfo: {
      type: Object,
      default: () => ({
        title: i18n_t('邀请成员组建团队'),
        desc: i18n_t('高效协作，统一管理'),
        btnText: i18n_t('组建团队'),
      }),
    },
  },
  setup(props, context) {
    const methods = {
      buildTeam() {
        context.emit('buildTeam');
      },
      uploadFile(action: string) {
        context.emit('uploadFileEvent', action);
      },
    };
    return {
      uploadImg,
      addMemberImg,
      ...methods,
    };
  },
});
